import { formControlStyles, defaultColor, defaultCheckedColor, formControlFontSizeStyles } from '../formControlStyles';
export const radioGroupStyles = Object.assign(Object.assign({}, formControlStyles), { radioButton: (uncheckedColor = defaultColor, checkedColor = defaultCheckedColor) => ({
        color: uncheckedColor,
        '& svg': Object.assign(Object.assign({}, formControlFontSizeStyles), { width: '1.3em', height: '1.3em' }),
        '&.Mui-checked': {
            color: checkedColor,
        },
    }) });
